const div = document.getElementById('calmac-app');
const route = div?.getAttribute('data-route');

const config = {
  route,
};

export default config;
